// extracted by mini-css-extract-plugin
module.exports = {"SectionPlan":"area-of-interest_SectionPlan__1BWTP","SectionName":"area-of-interest_SectionName__2JMSD","SectionContent":"area-of-interest_SectionContent__3dUwC"};